const getters = {
    landings: (state) => state.landings,
    languages: state => state.languages,
    teamsList: state => state.teamsList
}

export default getters
